var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"loading":_vm.loading,"headers":_vm.headers,"items":_vm.contactPersons,"items-per-page":10,"footer-props":_vm.footerProps,"sort-by":_vm.sortBy,"sort-desc":""},scopedSlots:_vm._u([{key:"item.salutation",fn:function(ref){
var item = ref.item;
return [(item.salutation)?_c('span',[_vm._v(_vm._s(_vm.$t(
          'PROFILE.SALUTATIONS_SHORT.' +
            item.salutation.substring(0, item.salutation.length - 1)
        )))]):_vm._e()]}},{key:"item.full_name",fn:function(ref){
        var item = ref.item;
return [_vm._v(_vm._s(_vm.getFullName(item)))]}},{key:"item.action",fn:function(ref){
        var item = ref.item;
return [_vm._t("actions",null,{"item":item})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }